export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const getAuthHeaders = () => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('auth_token') : null;
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
};

const handleResponse = async (resp) => {
  if (resp.status === 401) {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
  }

  let json = {};
  try {
    json = await resp.json();
  } catch (err) {
    // maybe empty body
  }

  if (!resp.ok || json.success === false) {
    throw new Error(json?.result?.message || json?.message || `Request failed with status ${resp.status}`);
  }

  // Handle nested result format if present
  return json.result !== undefined ? json.result : json;
};

const fetchWithTimeout = async (url, options = {}) => {
  const { timeout = 15000, ...fetchOptions } = options;
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, {
      ...fetchOptions,
      signal: controller.signal
    });
    clearTimeout(id);
    return response;
  } catch (error) {
    clearTimeout(id);
    if (error.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    throw error;
  }
};

const request = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  const headers = { ...getAuthHeaders(), ...options.headers };
  const resp = await fetchWithTimeout(url, { ...options, headers });
  return handleResponse(resp);
};

export const api = {
  get: (path, params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        qs.set(key, String(value));
      }
    });
    const queryString = qs.toString();
    const url = queryString ? `${path}?${queryString}` : path;
    return request(url, { method: 'GET' });
  },
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  patch: (path, body) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: 'DELETE' }),
};
